import { ENDPOINT_CONFIG } from "@/common/constants/api";
import { mapMarkerData, removeMapData } from "@/common/maps/features";
import { getDefaultMarkerOptions } from "@/common/maps/styles";
import { MAP_ICON_COLORS } from "@/common/constants/maps";
import { httpGet } from "@/services/api.service";

export { _addToMap as addToMap };
export { _removeFromMap as removeFromMap };
export { _getAttackTypesConfig as getAttackTypesConfig };
export { _getAttackTypes as getAttackTypes };
export { _getPerpetratorsConfig as getPerpetratorsConfig };
export { _getPerpetrators as getPerpetrators };
export { _getMaritimeSubcategoriesConfig as getMaritimeSubcategoriesConfig };
export { _getMaritimeSubcategories as getMaritimeSubcategories };
export { _getMaritimeVesselTypesConfig as getMaritimeVesselTypesConfig };
export { _getMaritimeVesselTypes as getMaritimeVesselTypes };

let attackTypesConfig = null;
let perpetratorsConfig = null;
let maritimeSubcategoriesConfig = null;
let maritimeVesselTypesConfig = null;

const _addToMap = (params) => {
  const SOURCE = {
    type: "FeatureCollection",
    features: params.data,
  };
  let iconColor = MAP_ICON_COLORS.disasters;
  if (params.iconColor) {
    iconColor = params.iconColor;
  }

  const PARAMS = {
    id: params.layerId,
    noCluster: false,
    iconColor: iconColor,
  };

  if (params.iconName) {
    PARAMS.iconName = params.iconName;
  }

  let markerOptions = getDefaultMarkerOptions(PARAMS);

  mapMarkerData({
    id: params.layerId,
    data: SOURCE,
    mapClickEvent: params.mapClickEvent,
    markerOptions: markerOptions,
    map: params.map,
    noCluster: false,
    clusterMapClickEvent: params.clusterMapClickEvent,
  });
};

const _removeFromMap = (params) => {
  removeMapData(params.map, params.layerId);
};

const _getAttackTypesConfig = async (force) => {
  if (!attackTypesConfig || force) {
    try {
      const URL = `${ENDPOINT_CONFIG}/verified/security/attack-types?ui=true`;
      const RESULT = await httpGet({ url: URL, noCache: true });
      const { data } = JSON.parse(RESULT);
      attackTypesConfig = data;
    } catch (error) {
      console.error(error);
      Promise.reject("Issue getting attack types config");
    }
  }
};

const _getAttackTypes = () => {
  return attackTypesConfig;
};

const _getPerpetratorsConfig = async (force) => {
  if (!perpetratorsConfig || force) {
    try {
      const URL = `${ENDPOINT_CONFIG}/verified/security/perpetrators?ui=true`;
      const RESULT = await httpGet({ url: URL, noCache: true });
      const { data } = JSON.parse(RESULT);
      perpetratorsConfig = data;
    } catch (error) {
      console.error(error);
      Promise.reject("Issue getting perpetrators config");
    }
  }
};

const _getPerpetrators = () => {
  return perpetratorsConfig;
};

const _getMaritimeSubcategoriesConfig = async (force) => {
  if (!maritimeSubcategoriesConfig || force) {
    try {
      const URL = `${ENDPOINT_CONFIG}/verified/maritime/subcategories?ui=true`;
      const RESULT = await httpGet({ url: URL, noCache: true });
      const { data } = JSON.parse(RESULT);
      maritimeSubcategoriesConfig = data;
    } catch (error) {
      console.error(error);
      Promise.reject("Issue getting maritime subcategories config");
    }
  }
};

const _getMaritimeSubcategories = () => {
  return maritimeSubcategoriesConfig;
};

const _getMaritimeVesselTypesConfig = async (force) => {
  if (!maritimeVesselTypesConfig || force) {
    try {
      const URL = `${ENDPOINT_CONFIG}/verified/maritime/vessel-types?ui=true`;
      const RESULT = await httpGet({ url: URL, noCache: true });
      const { data } = JSON.parse(RESULT);
      maritimeVesselTypesConfig = data;
    } catch (error) {
      console.error(error);
      Promise.reject("Issue getting maritime subcategories config");
    }
  }
};

const _getMaritimeVesselTypes = () => {
  return maritimeVesselTypesConfig;
};
